// extracted by mini-css-extract-plugin
module.exports = {"vulns_progress":"vulns_render_vulns_progress__1Eu67","warning_container":"vulns_render_warning_container__25CHU","warning_span":"vulns_render_warning_span__1ld-U"};